import { ThemeProvider } from "@emotion/react";
import "./App.css";
import RouterWrapper from "./router/Router";
import { defaultTheme } from "./styles/muiTheme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function App() {
  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={defaultTheme}>
        <RouterWrapper />
      </ThemeProvider>
    </LocalizationProvider>
    </>
  );
}

export default App;
